import request from '@/utils/request'

export const getQrCodeList = ({ page, size, batchCode, barcode, traceCode }) => {
  return request({
    url: `/trace/qrcode/${page}/${size}`,
    params: {
      batchCode,
      barcode,
      traceCode
    }
  })
}

export const postQrCodeEdit = (data) => {
  return request({
    method: 'post',
    url: '/trace/qrcode/print',
    data
  })
}

export const putQrCodeAdd = (data) => {
  return request({
    method: 'put',
    url: '/trace/qrcode',
    data
  })
}

export const deleteQrCodeDel = (id) => {
  return request({
    method: 'delete',
    url: `/trace/qrcode/${id}`
  })
}

export const delQrCodeList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/qrcode/all',
    data
  })
}

export const getQrCodeListPrint = (data) => {
  return request({
    method: 'post',
    url: '/trace/qrcode/print/ids',
    data
  })
}

export const getProductDetail = (barcode, orgId) => {
  return request({
    url: `/trace/product/qrcode/${barcode}/${orgId}`
  })
}

export const getProductInfo = (barcode) => {
  return request({
    url: `/trace/product/qrcode/info/${barcode}`
  })
}

export const getProductOrg = (barcode, productId) => {
  return request({
    url: `/trace/product/qrcode/org/${barcode}/${productId}`
  })
}

export const getCheckDetail = (batchCode) => {
  return request({
    url: `/trace/batch/check/batchCode/${batchCode}`
  })
}

export const initBatchCode = (traceCode) => {
  return request({
    url: `/trace/batch/check/qrcode/${traceCode}`
  })
}

export const getControlpointDetail = (batchCode) => {
  return request({
    url: `/trace/batch/controlpoint/batchCode/${batchCode}`
  })
}

export const getMaterialuseinfoDetail = (barcode) => {
  return request({
    url: `/trace/materialuseinfo/qrCode/${barcode}`
  })
}
